<template>
    <modal id="input" name="input-modal" @closed="cancelChanges">
        
        <b-container class="input-container">
            <b-row class="mb-20 input-title">
                {{title}}
            </b-row>

            <b-row class="mb-20">
                <b-form-textarea class="textarea-modal" 
                                 :placeholder="placeholder"
                                 :disabled="!isEdit" 
                                 v-model="text"/>         
            </b-row>

            <b-row v-if="isEdit" class="m-0">
                <b-col class="pr-10">
                    <b-button block 
                              variant="outline-primary"
                              class="button-cancel"
                              @click="cancel">
                        Отмена
                    </b-button>
                </b-col>

                <b-col class="pl-10">
                    <b-button block 
                              variant="outline-primary"
                              class="button-save"
                              @click="saveText">
                        Сохранить
                    </b-button>
                </b-col>
            </b-row>

            <b-row v-if="!isEdit" class="m-0">
                <b-button block 
                          variant="outline-primary"
                          class="button-save"
                          @click="hideModal">
                    Закрыть
                </b-button>
            </b-row>

        </b-container>

    </modal>
</template>

<script>
import '@/assets/styles/shared/inputModal.css'

export default {
    model: {
        prop: 'value',
        event: 'update'
    },
    props: {
        value: {
            type: String,
            default: ''
        },
        title: {
            type: String,
            default: 'Комментарий'
        },
        placeholder: {
            type: String,
            default: ''
        },
        isEdit: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        text: {
            get: function() {
                return this.value
            },
            set: function(val) {
                this.$emit('update', val);
            }
        }
    },
    data: function() {
        
        return {
            copyText: JSON.stringify(this.value)
        }
    },
    methods: {
        hideModal: function() {
            this.$modal.hide('input-modal');
        },
        cancelChanges: function() {
            this.text = JSON.parse(this.copyText);
        },
        cancel: function() {
            this.cancelChanges();
            this.hideModal();
        },
        saveText: function() {
            this.copyText = JSON.stringify(this.text);
            this.$emit('save', this.text);
            this.hideModal();
        }
    }
}
</script>